export default {
    // 获取每周、每半月的日期
    managerWorkTimePeriodList: "/payroll/managerWorkTime/periodList",
    // 雇员打卡汇总列表
    managerWorkTimeShow: "/payroll/managerWorkTime/show",
    // 雇员打开汇总列表-v2
     managerWorkTimeShowV2: "/payroll/managerWorkTime/showV2",
    //  根据ID获取雇员打卡详情
    getManagerWorkTimeById:"/payroll/managerWorkTime/showDetail",
    // 下载汇总表txt
    getShowStatistics:"/payroll/managerWorkTime/showStatistics",
    // 获取员工打卡详情
    getDailyRecord:"/payroll/managerWorkTime/showDailyRecord",

};